// @flow

import React from 'react';
import type { Node } from 'react';
import { connect } from 'react-redux';
import { Tile as StyledTile } from './tile.styled';
import { MostChosen } from './atoms';
import { getBestsellerLabel } from '../../../../../../store/configuratorSettings/selectors';

type OwnProps = {|
  active: boolean,
  onClick: Function,
  blocksPerRow: number,
  blockCount: number,
  boxed?: boolean,
  children: Node,
  mostChosen?: boolean,
  className?: string,
  variant?: ?string,
|};

type StateProps = {|
  bestsellerLabel: string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const Tile = ({
  active,
  onClick,
  children,
  blocksPerRow,
  blockCount,
  boxed,
  mostChosen,
  bestsellerLabel,
  className,
  variant,
}: Props) => (
  <StyledTile
    active={active}
    onClick={onClick}
    blocksPerRow={blocksPerRow}
    blockCount={blockCount}
    boxed={boxed || false}
    mostChosen={mostChosen}
    className={className}
    variant={variant}
  >
    {(mostChosen && !active) && <MostChosen>{bestsellerLabel}</MostChosen>}
    {children}
  </StyledTile>
);

Tile.defaultProps = {
  boxed: true,
  className: '',
  mostChosen: false,
  variant: null,
};

const mapStateToProps = (state): StateProps => ({
  bestsellerLabel: getBestsellerLabel(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(Tile);
